import { type DummyPrivatePageEndpointContextDataFragment } from '../../api/fragments/DummyPrivatePageEndpointContextData';
import withPrivateAccess from '../../utilities/withPrivateAccess';

export type PrivatePageProps = { endpoint: DummyPrivatePageEndpointContextDataFragment };

const PrivatePage = ({ endpoint }: PrivatePageProps) => <div>{endpoint.body}</div>;

export default withPrivateAccess(PrivatePage);
